import React from 'react'
import { Jumbotron, Col, Row, Container, Tabs, Tab} from 'react-bootstrap'
import { FadeOnUp } from 'nehoa'
import servicesImage from '../../assets/images/services.jpg'
import AdultServices from './AdultServices.js'
import AddictionServices from './AddictionServices.js'
import AdultResidentialServices from './AdultResidentialServices.js'
import CrisesNetworkServices from './CrisesNetworkServices.js'
import ChildrensServices from './ChildrensServices.js'
import ConfidentialityandNonDiscrimination from './ConfidentialityandNonDiscrimination.js'

export default function index() {
    return (
        <div>
            <Jumbotron style={{ paddingTop: '0', backgroundColor: '#999999', backgroundImage: `url(${servicesImage})`, backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', height: '40vh' }} fluid><FadeOnUp duration='3s'><div className="pageBannerTitleDiv"><p className="mainTitleFont">Services</p></div></FadeOnUp></Jumbotron>
            <Container>
                <Tabs defaultActiveKey="Adult Services" id="uncontrolled-tab-example">
                    <Tab eventKey="Adult Services" title="Adult Services">
                    <br />
                    <br />
                        <Row>
                            <Col>
                                <AdultServices />
                            </Col>
                        </Row>
                    </Tab>
                    <Tab eventKey="Adult Residential Services" title="Adult Residential Services">
                    <Row>
                        <Col>
                            <AdultResidentialServices />
                        </Col>
                    </Row>
                    </Tab>
                    <Tab eventKey="ChildrensServices" title="Children's Services">
                        <br /><br />
                        <Row>
                            <Col>
                                <ChildrensServices />
                            </Col>
                        </Row>
                    </Tab>
                    <Tab eventKey="AddictionServices" title="Addiction Services">
                    <br />    
                    <br />
                        <Row>        
                            <Col>
                                <AddictionServices />
                            </Col>
                        </Row>
                    </Tab>
                 <Tab eventKey="Crises Network Services" title="Crisis Network Services">
                    <Row>
                        <Col>
                            <CrisesNetworkServices />
                        </Col>
                    </Row>
                <br />
                 </Tab>
                    <Tab eventKey="Confidentiality and Non-Discrimination" title="Confidentiality and Non-Descrimination">
                        <Row>
                            <Col>
                                <ConfidentialityandNonDiscrimination />
                            </Col>
                        </Row>
                    </Tab>
                 </Tabs>
            </Container>
        </div>
    )
}
